import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { setStoredPosDeviceSecret } from '../config/api';
import { PosDeviceContext } from '../context/PosDeviceContext';

function readEnrollmentToken() {
  const query = new URLSearchParams(window.location.search);
  const fromQuery = query.get('token');
  if (fromQuery) return fromQuery;

  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  return hash.get('token');
}

// Survive React Strict Mode remounts in the same page load
let enrollInFlightToken = null;
let enrollInFlightPromise = null;

export default function PosDeviceEnroll() {
  const { refresh } = useContext(PosDeviceContext);
  const tokenRef = useRef(readEnrollmentToken());
  const started = useRef(false);
  const [state, setState] = useState({
    status: 'loading',
    message: 'Enrolling this POS terminal…',
    device: null
  });

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const token = tokenRef.current;
    if (!token) {
      setState({
        status: 'error',
        message:
          'The access token is missing. Open the full reusable link from Users → Store POS access links.',
        device: null
      });
      return;
    }

    (async () => {
      try {
        let data;
        if (enrollInFlightToken === token && enrollInFlightPromise) {
          data = await enrollInFlightPromise;
        } else {
          enrollInFlightToken = token;
          enrollInFlightPromise = api
            .post('/pos-devices/enroll', { token })
            .then((res) => res.data);
          data = await enrollInFlightPromise;
        }
        if (data.deviceSecret) {
          setStoredPosDeviceSecret(data.deviceSecret);
        }
        // Strip token from the address bar only after a successful enroll
        window.history.replaceState({}, document.title, '/pos/enroll');
        await refresh();
        setState({
          status: 'success',
          message: 'This browser is now the designated POS terminal for this store.',
          device: data.device
        });
      } catch (error) {
        enrollInFlightToken = null;
        enrollInFlightPromise = null;
        setState({
          status: 'error',
          message: error.response?.data?.error || 'Could not enroll this POS terminal.',
          device: null
        });
      }
    })();
  }, [refresh]);

  return (
    <main className="login-container">
      <section className="login-card" style={{ maxWidth: 560 }}>
        <h1>POS terminal enrollment</h1>
        <p>{state.message}</p>
        {state.device ? (
          <div className="card" style={{ margin: '18px 0', textAlign: 'left' }}>
            <strong>{state.device.device_name}</strong>
            <p style={{ marginBottom: 0 }}>Store: {state.device.store_name}</p>
          </div>
        ) : null}
        {state.status === 'success' ? (
          <Link className="btn btn-primary" to="/login">
            Continue to POS login
          </Link>
        ) : null}
        {state.status === 'error' ? (
          <Link className="btn btn-secondary" to="/login">
            Back to login
          </Link>
        ) : null}
      </section>
    </main>
  );
}
